import React from 'react';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import s from './DownloadOption.scss';
var DownloadOption = function (_a) {
    var value = _a.value, checked = _a.checked, title = _a.title, subtitle = _a.subtitle, onSelect = _a.onSelect;
    return (React.createElement(RadioButton, { className: s['root'], name: "download", size: "small", withMargins: true, value: value, checked: checked, onChange: onSelect },
        React.createElement("div", { className: s['text-block'] },
            React.createElement("div", { className: s['title'] }, title),
            subtitle && React.createElement("div", { className: s['subtitle'] }, subtitle))));
};
DownloadOption.displayName = 'DownloadOption';
export default DownloadOption;
//# sourceMappingURL=DownloadOption.js.map